import React, { useContext } from 'react';
import { Button, Typography, LinearProgress, Box } from '@mui/material';
import PropTypes from 'prop-types';
import backCircleArrow from '../../images/backCircleArrow.svg';
import {
  COLOR5,
  PERSONAL_INFO,
  ADDRESS_INFO,
  COMPLIANCE_INFO,
  PRODUCT_INFO,
  FUNDING_INFO,
  CONSENT_INFO,
  FEATURE_INFO,
} from '../../constants';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { BackCircleArrow } from '../../images/svg/CustomizedSVG';
import { commonTernary, isBundle, isWebComponentFlow } from '../commonCode';
import Header from '../../WebComponents/components/Header';

export default function LineStepper({ handleBack, stepValue }) {
  const baseContext = isWebComponentFlow();
  const { theme, productName, currentStep } = baseContext;
  const isBundleProduct = isBundle(productName);
  const totalSteps = 7;
  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '30px',
      width: '100%',
    },
    progressBarWrapper: {
      flexGrow: 1,
      margin: '0 16px',
    },
    progressBar: {
      height: '10px',
      borderRadius: '30px',
      backgroundColor: commonTernary(
        isBundleProduct,
        theme?.palette?.fieldsBackground?.main,
        '#eeeeee'
      ),
      '& .MuiLinearProgress-bar': {
        backgroundColor: commonTernary(
          isBundleProduct,
          theme?.palette?.orientalPrimary?.main,
          '#eeeeee'
        ),
        borderRadius: '30px',
      },
    },
    stepperNumber: {
      fontSize: '14px',
      fontWeight: 700,
    },
    backBtn: {
      minWidth: '20px',
      padding: 0,
    },
    headerstyle: {
      marginLeft: '-36px',
      '@media (max-width:600px)': { marginLeft: '-14px' },
    },
  };
  const progressValue = ((stepValue + 1) / totalSteps) * 100;

  return (
    <>
      {baseContext?.wcFlow && !baseContext?.isMobileApp && (
        <Box sx={styles.headerstyle}>
          <Header />
        </Box>
      )}
      <Box sx={styles.container}>
        <Button size="small" sx={styles.backBtn} onClick={handleBack}>
          {/* <img src={backCircleArrow} alt="back button" width={24} height={24} /> */}
          <BackCircleArrow
            height="24px"
            width="24px"
            color={theme?.palette?.orientalPrimary?.main}
          />
        </Button>

        <Box sx={styles.progressBarWrapper}>
          <LinearProgress
            variant="determinate"
            value={progressValue}
            {...(baseContext?.wcFlow ? { className: 'progress-bar' } : { sx: styles.progressBar })}
          />
        </Box>

        <Typography sx={styles.stepperNumber}>
          {stepValue + 1}/{totalSteps}
        </Typography>
      </Box>
    </>
  );
}

LineStepper.propTypes = {
  handleBack: PropTypes.func.isRequired,
  stepValue: PropTypes.number,
};
